import UnfollowModal from "../../components/Blogfolio/UnfollowModal";
import { useModalStore } from "../../store/ModalStore";

const MODAL_COMPONENTS = {
  UNFOLLOW: UnfollowModal,
};

const RootModal = () => {
  const { modalType, modalProps } = useModalStore();
  const CurrentModal = MODAL_COMPONENTS[modalType];

  if (CurrentModal) {
    return <CurrentModal {...modalProps} />;
  } else {
    return null;
  }
};

export default RootModal;
